// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-212529: #212529;
  --color-ffd333: #6B3F4F;
  --color-47ad24: #F0E4D2;
  --color-e52e2e: #e52e2e;
  --color-828599: #352919;
  --color-3d464d: #ed464d;
  --color-c3d4da: #ced4da;
}


.bg-primagry{
  background-color: #6B3F4F;
}

.green {
  color: var(--color-47ad24);
  font-size: 14px;
  font-family: Roboto !important;
}
.red {
  color: var(--color-212529);
  font-size: 14px;
  font-family: Roboto !important;
}
.quill {
  background-color: #ffffff;
}

.form-control {
  box-shadow: none;
  border-color: var(--color-c3d4da);
}
.title {
  font: 28px;
  font-family: Roboto !important;
  color: var(--color-212529);
}

.sub-title {
  font: 24px;
  font-family: Roboto !important;
  color: var(--color-212529);
}
.desc {
  font: 14px;
  font-family: Roboto !important;
  color: var(--color-828599);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;AACzB;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,UAAU;EACV,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,8BAA8B;EAC9B,0BAA0B;AAC5B","sourcesContent":[":root {\n  --color-212529: #212529;\n  --color-ffd333: #6B3F4F;\n  --color-47ad24: #F0E4D2;\n  --color-e52e2e: #e52e2e;\n  --color-828599: #352919;\n  --color-3d464d: #ed464d;\n  --color-c3d4da: #ced4da;\n}\n\n\n.bg-primagry{\n  background-color: #6B3F4F;\n}\n\n.green {\n  color: var(--color-47ad24);\n  font-size: 14px;\n  font-family: Roboto !important;\n}\n.red {\n  color: var(--color-212529);\n  font-size: 14px;\n  font-family: Roboto !important;\n}\n.quill {\n  background-color: #ffffff;\n}\n\n.form-control {\n  box-shadow: none;\n  border-color: var(--color-c3d4da);\n}\n.title {\n  font: 28px;\n  font-family: Roboto !important;\n  color: var(--color-212529);\n}\n\n.sub-title {\n  font: 24px;\n  font-family: Roboto !important;\n  color: var(--color-212529);\n}\n.desc {\n  font: 14px;\n  font-family: Roboto !important;\n  color: var(--color-828599);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
